import { render, staticRenderFns } from "./activityManagement.vue?vue&type=template&id=828fa9f6&scoped=true"
import script from "./activityManagement.vue?vue&type=script&lang=js"
export * from "./activityManagement.vue?vue&type=script&lang=js"
import style0 from "./activityManagement.vue?vue&type=style&index=0&id=828fa9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828fa9f6",
  null
  
)

export default component.exports